import React from 'react'
import Component from 'components/component'
import Dropdown from 'components/dropdown'
import { DI } from 'modules'
import DropdownAudioItem from './dropdown-audio-item'

class LiveAudio extends Component {
  static defaultProps = {
    onSelectLanguage() {},
  }
  renderList() {
    const audiotrackList =
      this.props.common.strings['page.lives.view.audiotrack.list']
    return (
      <span className="live-audio__value">
        {this.props.liveEvent.languages
          .sort((a, b) => parseInt(a.position) - parseInt(b.position))
          .map(item => audiotrackList[item.id] || item.name)
          .join(' · ')}
      </span>
    )
  }

  renderDropdown(isRecordings) {
    const filteredLanguages = [
      ...new Map(
        this.props.liveEvent.languages
          .sort((a, b) => b.id - a.id)
          .map(item => [item['name'], item])
      ).values(),
    ]

    const langs = filteredLanguages.sort(
      (a, b) => parseInt(a.position) - parseInt(b.position)
    )

    // const defaultLang = langs.find((x) => x.position == 0);
    return (
      <div className="live-audio-select">
        <Dropdown
          items={langs}
          getTitle="name"
          getValue="id"
          value={this.props.selectedLanguageID}
          onChange={this.props.onSelectLanguage}
          headerModificator="big"
          placeholder="Choose audiotrack"
          {...(isRecordings
            ? { renderItem: props => <DropdownAudioItem {...props} /> }
            : {})}
        />
      </div>
    )
  }

  render() {
    const { languages, status, cutting_available } = this.props.liveEvent
    //const isSignedIn = this.props.user.isSignedIn;
    const isRecordings = status === 'finished' && cutting_available
    const liveOrRecordings =
      status === 'live' || status === 'next' || isRecordings

    let renderMethod

    if (
      // isSignedIn &&
      liveOrRecordings &&
      languages.length > 1 &&
      !this.props.disabled
    ) {
      renderMethod = this.renderDropdown.bind(this)
    } else {
      renderMethod = this.renderList.bind(this)
    }

    return (
      <div className="live-audio">
        <span className="live-audio__label">
          {this.props.common.strings['page.lives.view.audiotrack']}
        </span>
        {renderMethod(isRecordings)}
      </div>
    )
  }
}
export default DI(['common', 'user'])(LiveAudio)
